import { SelectedLocation } from "components"
import type React from "react"
import {
    selectActiveCloudinaryAssetId,
    selectActiveTitle,
    toggleOrgGroupModal,
    useAppDispatch,
    useAppSelector
} from "services"

const title = (locationTitle: string): string | undefined =>
    typeof locationTitle === "string" && locationTitle.length > 0 ? locationTitle : undefined

const OrgGroupSelectorBox: React.FC = () => {
    const dispatch = useAppDispatch()

    const locationTitle = useAppSelector(selectActiveTitle)
    const cloudinaryAssetId = useAppSelector(selectActiveCloudinaryAssetId)

    const handleOrgGroupSelectorToggle = () => {
        dispatch(toggleOrgGroupModal())
    }

    return (
        <SelectedLocation
            title={title(locationTitle) ?? "Select Locale"}
            locale={""}
            cloudinaryAssetId={cloudinaryAssetId}
            onClick={handleOrgGroupSelectorToggle}
        />
    )
}

export default OrgGroupSelectorBox
